import {CardHelp} from '../../shared/components/CardHelp'
interface CoverageGaugeProps {
  label: string;
  value: number;
  max: number;
  target: number;
  color: string;
  unit?: string;
  help?: string;
}

export const CoverageGauge = ({ label, value, max, target, color, unit = '', help }: CoverageGaugeProps) => {
  const pct = Math.min((value / max) * 100, 100);
  const targetPct = Math.min((target / max) * 100, 100);

  return (
    <div className="relative space-y-2">
      <CardHelp content={help || `Compara ${label.toLowerCase()} com a meta indicada pela marca vertical.`} className="absolute -right-1 -top-1" />
      <div className="flex items-center justify-between pr-7">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <span className="text-sm font-bold text-gray-900 tabular-nums">
          {value.toFixed(1)}{unit}
        </span>
      </div>
      <div className="relative h-3 bg-gray-100 rounded-full overflow-visible">
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-700 ease-out"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
        <div
          className="absolute top-[-3px] w-0.5 h-[18px] bg-gray-400 rounded-full"
          style={{ left: `${targetPct}%` }}
          title={`Meta: ${target}${unit}`}
        />
      </div>
      <div className="flex justify-between">
        <span className="text-[10px] text-gray-400">0</span>
        <span className="text-[10px] text-gray-400">Meta: {target}{unit}</span>
      </div>
    </div>
  );
};
